export default __webpack_public_path__ + "locales/pt-BR/ChangePhoneDialog.json?hash=8890bc89ec6b8e2f67f5329c5ad77947";